angular.module('app').config(saeChannelsRouting);

function saeChannelsRouting($routeProvider) {
  $routeProvider.when('/sale_channels_and_sources', {
    pageTitle: 'SALE_CHANNELS_AND_SOURCES',
    template: '<sale-channels-page></sale-channels-page>',
    breadcrumb: {
      label: 'COMPANY_SETTINGS',
      parent: 'ng/company_settings',
    },
    accessPermission: 'index_salechannel_accountadmin',
    authReq: true,
  });
}

saeChannelsRouting.$inject = ['$routeProvider'];
